import { render, staticRenderFns } from "./PayBoxReclaimProducts.vue?vue&type=template&id=77063c3c&"
import script from "./PayBoxReclaimProducts.vue?vue&type=script&lang=js&"
export * from "./PayBoxReclaimProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77063c3c')) {
      api.createRecord('77063c3c', component.options)
    } else {
      api.reload('77063c3c', component.options)
    }
    module.hot.accept("./PayBoxReclaimProducts.vue?vue&type=template&id=77063c3c&", function () {
      api.rerender('77063c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-reclaim-products/PayBoxReclaimProducts.vue"
export default component.exports